import * as React from 'react';

const CreditCardActive = (props) => (
  <svg
    width={25}
    height={25}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.128 10.668h19.996c-.012-2.175-.108-3.353-.877-4.121-.878-.879-2.293-.879-5.121-.879h-8c-2.828 0-4.243 0-5.121.879-.769.768-.865 1.946-.877 4.121Zm19.998 2h-20v2c0 2.828 0 4.243.879 5.121.878.879 2.293.879 5.121.879h8c2.828 0 4.243 0 5.121-.879.879-.878.879-2.293.879-5.121v-2Zm-15 3a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2h-.01Z"
      fill="#fff"
    />
  </svg>
);

export default CreditCardActive;
